import { IProvinceModel } from './provinceModel';
import { ISoftwareModel } from './softwareModel';
import { IOrganizationStep1FormResultModel } from '../../components/registration/organization/step1/organizationStep1FormModel';

export interface IOrganizationModel {
    id?: string;
    name: string;
    legalName: string;
    type: string;
    operatingYear: number;
    number: string;
    email: string;
    address: string;
    city: string;
    province: number | IProvinceModel;
    zip: string;
    retailBanner: string;
    managementSoftware: number | ISoftwareModel;
    managementSoftwareOther: string;
    agreeManagementSoftware: boolean;
    phone: string;
    ext: string;
    openServices: boolean; // not in form
    nonClinical: boolean;
    ownershipChange: boolean;
    ownershipChangeDate?: string;
    legalNameChange: boolean;
    legalNameChangeDate?: string;
    businessNumber: string;
    gstHst: string;
    rt: string;
}

export const organizationModelFromFormData = (
    formData: IOrganizationStep1FormResultModel
): IOrganizationModel => {
    return {
        name: formData.form_organization_step_1_field_commercial_name,
        legalName: formData.form_organization_step_1_field_legal_name,
        type: formData.form_organization_step_1_field_organization_type, // role from account
        operatingYear: +formData.form_organization_step_1_field_operation,
        number: formData.form_organization_step_1_field_cspaat,
        email: formData.form_organization_step_1_field_email,
        address: formData.form_organization_step_1_field_address,
        city: formData.form_organization_step_1_field_city,
        zip: formData.form_organization_step_1_field_postal_code,
        retailBanner: formData.form_organization_step_1_field_commercial_banner,
        managementSoftware: Number(formData.form_organization_step_1_field_managing_software),
        managementSoftwareOther: formData.form_organization_step_1_field_managing_software_other,
        agreeManagementSoftware:
            formData.form_organization_step_1_field_authorization_communication,
        phone: formData.form_organization_step_1_field_phone,
        ext: formData.form_organization_step_1_field_phone_ext,
        ownershipChange: formData.form_organization_step_1_field_enterprise_property_transfer,
        ownershipChangeDate:
            formData.form_organization_step_1_field_enterprise_property_transfer_date,
        businessNumber: formData.form_organization_step_1_field_enterprise_number.toString(),
        gstHst: formData.form_organization_step_1_field_enterprise_tps.toString(),
        rt: formData.form_organization_step_1_field_enterprise_rt.toString(),
        legalNameChange: formData.form_organization_step_1_field_enterprise_legal_name_change,
        legalNameChangeDate:
            formData.form_organization_step_1_field_enterprise_legal_name_change_date,
        province: +formData.form_organization_step_1_field_province,

        // Deprecated fields
        openServices: false,
        nonClinical: false,
    } as IOrganizationModel;
};
